import styles from 'views/PageSelection/PageSelection.css';
import React, { Component, PropTypes } from 'react';
import _ from '../../utils/lodash';
import PageviewEventDropdown from 'views/PageviewEvent/PageviewEventDropdown';
import { domain, path, empty } from 'constants/operators';

class PageSelection extends Component {
  static propTypes = {
    onUpdatePageview: PropTypes.func,
    onPathConditionChange: PropTypes.func,
    pageview: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
    loading: PropTypes.bool,
    mobileVersion: PropTypes.bool
  }

  state = {
    input: {
      domain: document.location.hostname,
      path: document.location.pathname
    },
    operator: {},
    changed: false,
    showOptions: false
  }

  componentDidMount () {
    this.init(this.props);
  }

  componentWillReceiveProps (nextProps) {
    const { pageview } = nextProps;
    if (_.isEmpty(pageview)) {
      this.onUpdate(this.state.input, this.state.operator);
    }
  }

  init = (props) => {
    const { pageview } = props;
    if (!_.isEmpty(pageview) && pageview instanceof Array) {
      const { input, operator } = adaptPageview(pageview);
      this.setState({
        input,
        operator,
        showOptions: pageview.some(item => item.name === 'hash' || item.name === 'query')
      });
      this.onUpdate(input, operator);
    } else if (!_.isEmpty(pageview) && pageview instanceof Object) {
      const { url, name } = pageview.input;
      const input = {
        domain: url.hostname,
        path: url.pathname,
        query: url.query,
        hash: url.hash,
        name: name
      };
      this.setState({
        input,
        showOptions: (input.hash || input.query)
      });
      this.onUpdate(input, this.state.operator);
    } else {
      this.onUpdate(this.state.input, this.state.operator);
    }
  }

  render () {
    const { input, operator, showOptions } = this.state;
    const { loading, mobileVersion } = this.props;
    return (
      <div className={styles.container}>
        <PageviewEventDropdown
          loading={loading}
          mobileVersion={mobileVersion}
          borderStyle={'left-clear'}
          dropdown={operator['domain'] || domain[0]}
          input={input['domain']}
          onClearInput={this.clearInput('domain')}
          label={'Domain'}
          onDropdownChange={this.handleSelectDropdown('domain')}
          onTextChange={this.onChangeInput('domain')}
          options={domain}
          placeholder={'coffeeroasters.com'}
          />
        <PageviewEventDropdown
          loading={loading}
          mobileVersion={mobileVersion}
          borderStyle={'left-clear'}
          dropdown={operator['path'] || (input['path'] ? path[0] : empty)}
          input={input['path']}
          label={'path'}
          onClearInput={this.clearInput('path')}
          onDropdownChange={this.handleSelectDropdown('path')}
          onTextChange={this.onChangeInput('path')}
          options={path}
          placeholder={'/'}
          />
        <span onClick={this.showAdvancedOptions} className={styles.textButton}>
          Advanced Options ▾
        </span>
        {
          showOptions &&
            <div className={styles.container}>
              <PageviewEventDropdown
                loading={loading}
                mobileVersion={mobileVersion}
                borderStyle={'left-clear'}
                dropdown={operator['query'] || empty}
                input={input['query']}
                label={'Query'}
                onClearInput={this.clearInput('query')}
                onDropdownChange={this.handleSelectDropdown('query')}
                onTextChange={this.onChangeInput('query')}
                options={path}
                placeholder={'?'}
                />
              <PageviewEventDropdown
                loading={loading}
                mobileVersion={mobileVersion}
                borderStyle={'left-clear'}
                dropdown={operator['hash'] || empty}
                input={input['hash']}
                label={'Hash'}
                onClearInput={this.clearInput('hash')}
                onDropdownChange={this.handleSelectDropdown('hash')}
                onTextChange={this.onChangeInput('hash')}
                options={path}
                placeholder={'#'}
                />
              <PageviewEventDropdown
                loading={loading}
                mobileVersion={mobileVersion}
                borderStyle={'left-clear'}
                dropdown={operator['name'] || empty}
                input={input['name']}
                label={'Title'}
                onClearInput={this.clearInput('name')}
                onDropdownChange={this.handleSelectDropdown('name')}
                onTextChange={this.onChangeInput('name')}
                options={path}
                placeholder={'title'}
                />
            </div>
        }
      </div>
    );
  }

  clearInput = (key) => (e) => {
    const input = {
      ...this.state.input,
      [key]: ''
    };
    this.setState({ input });
    this.onUpdate(input, this.state.operator);
  }

  onChangeInput = (type) => (e) => {
    const input = {
      ...this.state.input,
      [type]: e.target.value
    };
    this.setState({
      input,
      changed: true,
      nameTaken: false
    });
    this.props.onPathConditionChange(input, this.state.operator, true);
  }

  handleSelectDropdown = (type) => (selected) => {
    const operator = {
      ...this.state.operator,
      [type]: selected
    };
    this.setState(() => ({
      operator,
      changed: true
    }));
    this.props.onPathConditionChange(this.state.input, operator);
  };

  onUpdate (input, operator) {
    const { onUpdatePageview } = this.props;
    onUpdatePageview(input, operator);
  }

  showAdvancedOptions = () => {
    this.setState({
      showOptions: !this.state.showOptions
    });
  }
}

const adaptPageview = (arr) => {
  let input = {};
  let operator = {};
  arr.forEach((item) => {
    input[item.name] = item.value;
    operator[item.name] = item.operator;
  });

  return {
    input,
    operator
  };
};

export default PageSelection;



/** WEBPACK FOOTER **
 ** ./src/views/PageSelection/PageSelection.js
 **/